import React from 'react'
import styled from 'styled-components'
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined'

const ITEMS = [
  { tone: 'preview', label: 'Preview', meaning: 'open the document to check what it is' },
  { tone: 'keep', label: 'Keep', meaning: 'it’s fine, so stop flagging it and leave it in place' },
  { tone: 'hide', label: 'Hide', meaning: 'keep the file but remove it from lists and Guru' },
  { tone: 'delete', label: 'Delete', meaning: 'remove it from the Building Passport (restorable from the history)' }
]

const ReviewActionsLegend = ({ hasSharepoint = false }) => (
  <Legend aria-label='What each action does'>
    <Title>What each action does</Title>
    <Items>
      {ITEMS.map(i => (
        <Item key={i.label}>
          <Tag $tone={i.tone}>{i.label}</Tag>
          <Meaning>{i.meaning}</Meaning>
        </Item>
      ))}
    </Items>
    {hasSharepoint && (
      <SpNote>
        <CloudSyncOutlinedIcon style={{ fontSize: 16 }} />
        <span>
          <b>Files synced from SharePoint can’t be deleted here.</b> They show <b>Mark</b> instead of Delete. This only adds them to the
          {' '}<b>SharePoint cleanse</b> list, so you can then delete them in SharePoint at the source. Nothing is removed from SharePoint automatically.
        </span>
      </SpNote>
    )}
  </Legend>
)

export default ReviewActionsLegend

const TONES = {
  preview: { bg: '#f1f3f7', fg: '#4a4f5e' },
  keep: { bg: '#dcfce7', fg: '#15803d' },
  hide: { bg: '#fef3c7', fg: '#b45309' },
  delete: { bg: '#fdecea', fg: '#b00020' }
}

const Legend = styled.div`
  background: #fafbfc;
  border: 1px solid #eef0f3;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 14px;
`

const Title = styled.div`
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7a8194;
  margin-bottom: 9px;
`

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
`

const Item = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
`

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 800;
  background: ${({ $tone }) => TONES[$tone].bg};
  color: ${({ $tone }) => TONES[$tone].fg};
`

const Meaning = styled.span`
  color: #5b6270;
`

const SpNote = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 11px;
  padding-top: 11px;
  border-top: 1px dashed #e4e7ec;
  font-size: 12.5px;
  line-height: 1.5;
  color: #475569;

  svg { color: #64748b; flex-shrink: 0; margin-top: 1px; }
  b { color: #1b2233; font-weight: 700; }
`
